import { DecodedJwt } from '.';
import { useAuthContext } from './auth.resource';
import { decodeJwtPayload, getJwtToken, isJwtValid } from './jwt-manager';
import { useOrganization } from './organization.resource';
import { useUser } from './user.resource';

export function useAuth() {
  const { currentUser, has } = useAuthContext();
  useUser();
  const { organization, isLoaded: isOrgLoaded } = useOrganization() as {
    organization?: { _id?: string; externalOrgId?: string };
    isLoaded: boolean;
  };

  const jwt = getJwtToken();
  const hasToken = isJwtValid(jwt);
  const decodedJwt = hasToken ? decodeJwtPayload<DecodedJwt>(jwt) : null;
  const isLoaded = hasToken ? isOrgLoaded : true;
  const isSignedIn = hasToken;

  return {
    isLoaded,
    isSignedIn,
    userId: currentUser?.externalId ?? decodedJwt?._id,
    orgId: organization?.externalOrgId ?? organization?._id,
    has,
  };
}
